import styled from '@emotion/styled';
import { getUpscGsPaperTagStyle } from './upscGsPaperTagUtils';

const Tag = styled.span<{ $background: string; $color: string }>`
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
  text-transform: uppercase;
  background: ${({ $background }) => $background};
  color: ${({ $color }) => $color};
`;

export interface UpscGsPaperTagProps {
  label: string;
  index: number;
}

const UpscGsPaperTag = ({ label, index }: UpscGsPaperTagProps) => {
  const { background, color } = getUpscGsPaperTagStyle(index);

  return (
    <Tag $background={background} $color={color}>
      {label}
    </Tag>
  );
};

export default UpscGsPaperTag;
